// extracted by mini-css-extract-plugin
export default {"formHeaderBlock":"HeaderForAuth_formHeaderBlock__prRUl","closeButtonBorder":"HeaderForAuth_closeButtonBorder__cGpIF","closeButton":"HeaderForAuth_closeButton__O6hzx"};